import { clsx } from 'clsx'
import React from 'react'

export function TagBox({children}: {children: React.ReactNode}) {
  return (
    <div className={clsx(
      "sa-bg-yellow sa-text-blue tw-inline-block tw-rounded-full tw-px-2 tw-text-[12px] tw-mx-4",
      "md:tw-absolute md:-tw-bottom-2")}
    >{children}</div>
  )
}